import React from 'react';
import { useController } from 'react-hook-form';

// components
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';

const Checkbox = ({ name, control, rules, label, ...props }) => {
    const {
        field: { value, onChange, ...field },
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    return (
        <div className="FormField FormField--checkbox">
            <div className="FormField__checkboxGroup">
                <input
                    {...field}
                    {...props}
                    id={name}
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <FormFieldLabel label={label} name={name} rules={rules}/>

            </div>
            <FormFieldError error={error} />
        </div>
    );
};

export default Checkbox;